import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SectionHeading from "../SectionHeading/SectionHeading";

const rubikfont = { fontFamily: "Rubik, sans-serif" };

const PRICE_BRACKETS_V2 = [
    { min: 0, max: 299, label: "Under ₹299", sublabel: "Everyday Picks", emoji: "💄", bgcolor: "#fff5f7", border: "#f48fb1", accent: "#e91e63" },
    { min: 300, max: 499, label: "₹300 – ₹499", sublabel: "Great Value", emoji: "✨", bgcolor: "#fffde7", border: "#ffe082", accent: "#f57c00" },
    { min: 500, max: 999, label: "₹500 – ₹999", sublabel: "Premium Picks", emoji: "💅", bgcolor: "#f1f8e9", border: "#aed581", accent: "#558b2f" },
    { min: 1000, max: 1499, label: "₹1000 – ₹1499", sublabel: "Luxury Zone", emoji: "👑", bgcolor: "#f3e5f5", border: "#ce93d8", accent: "#6a1b9a" },
    { min: 1500, max: 4999, label: "₹1500 & Above", sublabel: "Indulge Yourself", emoji: "🌟", bgcolor: "#e3f2fd", border: "#90caf9", accent: "#1565c0" },
];

const ShopByPrice = () => {
    const navigate = useNavigate();

    const handleBracketClick = (min, max) => {
        navigate(`/products?minPrice=${min}&maxPrice=${max}&title=${encodeURIComponent(`₹${min === 0 ? 1 : min} – ₹${max}`)}`);
        window.scrollTo(0, 0);
    };

    return (
        <Box sx={{ py: { xs: 2.5, md: 3.5 }, bgcolor: "#fff" }}>
            <Container maxWidth="xl">

                {/* Standardized Header */}
                <SectionHeading kicker="Find Your Range" title="Shop By Price" />

                {/* Price Cards */}
                <Box sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)", md: "repeat(5, 1fr)" },
                    gap: { xs: 1.25, md: 2 },
                }}>
                    {PRICE_BRACKETS_V2.map((bracket) => (
                        <Box
                            key={bracket.max}
                            onClick={() => handleBracketClick(bracket.min, bracket.max)}
                            sx={{
                                position: "relative",
                                borderRadius: "16px",
                                p: { xs: 1.75, md: 2.25 },
                                cursor: "pointer",
                                bgcolor: bracket.bgcolor,
                                border: `1px solid ${bracket.border}55`,
                                overflow: "hidden",
                                transition: "all .25s ease",
                                "&:hover": { transform: "translateY(-4px)", boxShadow: `0 12px 26px ${bracket.border}55`, borderColor: bracket.border },
                                "&:hover .go": { transform: "translateX(4px)" },
                            }}
                        >
                            <Box sx={{ position: "absolute", right: -8, top: -8, fontSize: { xs: "44px", md: "54px" }, opacity: 0.18, lineHeight: 1, pointerEvents: "none" }}>{bracket.emoji}</Box>
                            <Typography sx={{ fontSize: "10.5px", fontWeight: 600, color: bracket.accent, opacity: 0.8, textTransform: "uppercase", letterSpacing: "1.2px", mb: 0.5, ...rubikfont }}>
                                {bracket.sublabel}
                            </Typography>
                            <Typography sx={{ fontSize: { xs: "17px", md: "20px" }, fontWeight: 800, color: "#1a1a1a", lineHeight: 1.15, mb: 1.5, ...rubikfont }}>
                                {bracket.label}
                            </Typography>
                            <Typography sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, fontSize: "11px", fontWeight: 700, color: bracket.accent, letterSpacing: "1px", textTransform: "uppercase", ...rubikfont }}>
                                Shop now <span className="go" style={{ transition: "transform .2s" }}>→</span>
                            </Typography>
                        </Box>
                    ))}
                </Box>

            </Container>
        </Box>
    );
};

export default ShopByPrice;
